<div *ngIf="mode==='normal'" class="max-w-[1920px] mx-auto px-4 md:px-8 mt-2 mb-6 md:mb-8">
    <div class="flex items-center gap-5 border-b border-border pb-4">
        <span class="w-1.5 h-7 md:h-9 rounded-sm bg-primary shadow-sm shrink-0"></span>
        <h2 class="text-[1.75rem] md:text-[2.25rem] font-extrabold text-text-main tracking-tight m-0">{{nombre}}</h2>
    </div>
</div>